  <div class="so-header-actions" 
       [class.so-header-actions--has-right]="showActionButton() || showSearch()"
       [class.so-header-actions--has-content]="hasContent"
       [class.so-header-actions--no-border]="!showBorderBottom()">
    <div class="so-header-actions__left">
      @if (headerIcon()) {
        <so-premium-icon-ui
          [icon]="headerIcon()"
          [color]="headerIconColor()"
          [size]="18"
          [padding]="8"
          [borderRadius]="10" />
      }
      <div class="so-header-actions__titles">
        @if (title()) {
          <span class="so-header-actions__title">{{ title() }}</span>
        }
        @if (subtitle()) {
          <span class="so-header-actions__subtitle">{{ subtitle() }}</span>
        }
      </div>
    </div>
    <div class="so-header-actions__content">
      <ng-content #content></ng-content>
    </div>
    <div class="so-header-actions__middle">
      @if (showTabs() && tabs().length > 0) {
        <div class="so-header-actions__tabs">
          <so-tabs-ui
          [tabs]="tabs()"
          [activeIndex]="activeTabIndex()"
          [display]="'pills'"
          [showContent]="false"
          (tabChanged)="onTabChanged($event)" />
        </div>
      }
    </div>
    @if (showActionButton() || showSearch()) {
      <div class="so-header-actions__right">
        @if (showActionButton()) {
          <so-button-gradient-ui
            [text]="actionButtonText()"
            (click)="onActionButtonClick()"
            [icon]="actionButtonIcon()"
          ></so-button-gradient-ui>
        }
        @if (showSearch()) {
          <so-input-ui
            [placeholder]="searchPlaceholder()"
            [type]="'search'"
            [inputHeight]="36"
            (input)="onSearchChange($any($event.target).value)"
          />
        }
      </div>
    }
  </div>
